
import React from 'react';
import { FormProvider } from 'react-hook-form';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import MDBox from '../../components/MDBox';
import MDButton from '../../components/MDButton';
import MDTypography from '../../components/MDTypography';

import { useNewTeamForm } from './useNewTeamForm';
import TeamLeaderStep from './steps/TeamLeaderStep';
import TeamDataStep from './steps/TeamDataStep';
import ConfirmationStep from './steps/ConfirmationStep';
import { Box } from '@mui/material';

const steps = ['قائد الفريق', 'بيانات الفريق', 'تأكيد'];

const NewTeam = () => {
  const { methods, activeStep, handleNext, handleBack, submitForm, isLoading, isSuccess, isError, error } = useNewTeamForm();

  const getStepContent = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return <TeamLeaderStep />;
      case 1:
        return <TeamDataStep />;
      case 2:
        return <ConfirmationStep />;
      default:
        return null;
    }
  };

  return (
    
          <Card>
            <MDBox pt={4} pb={3} px={3}>
              <MDBox mb={3}>
                <MDTypography variant="h4" >
                    انشاء فريق جديد
                </MDTypography>
              </MDBox>
              <Box sx={{width:"100%"}}>
                <Stepper activeStep={activeStep}  alternativeLabel sx={{background:"transparent" ,boxShadow:"none" ,width:"100%"}}>
                    {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                    ))}
                </Stepper>
                </Box>
              <MDBox mt={3} p={2}>
                 <FormProvider {...methods}>
                   <form onSubmit={e => e.preventDefault()}> 
                      {/* We prevent default submit to handle it via buttons manual onclick or separate handling */}
                     {getStepContent(activeStep)}
                     
                     <MDBox mt={4} display="flex" justifyContent="space-between">
                       <MDButton
                         onClick={handleBack}
                         disabled={activeStep === 0}
                         variant="outlined"
                         color="text"
                         sx={{
                           color:"text.border" 

                         }}
                       >
                         السابق
                       </MDButton>
                        
                       {activeStep === steps.length - 1 ? (
                         <MDButton
                           variant="gradient"
                           color="primary"
                           onClick={submitForm}
                           disabled={isLoading}
                         >
                           {isLoading ? 'جاري الاضافة...' : 'اضافة فريق جديد'}
                         </MDButton>
                       ) : (
                         <MDButton
                           variant="gradient"
                           color="primary"
                           onClick={handleNext}
                         >
                           التالي
                         </MDButton>
                       )}
                     </MDBox>

                     {isError && (
                        <MDBox mt={2}>
                            <MDTypography color="error" variant="caption">
                                خطأ في اضافة الفريق: {error?.data?.message || error?.message || "حدث خطأ غير معروف"}
                            </MDTypography>
                        </MDBox>
                     )}
                     
                     {isSuccess && (
                        <MDBox mt={2}>
                             <MDTypography color="success" variant="caption">
                                فريق جديد تم اضافته بنجاح!
                            </MDTypography>
                        </MDBox>
                     )}
                   </form>
                 </FormProvider>
              </MDBox>
            </MDBox>
          </Card>
      
  );
};

export default NewTeam;